// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Tw7s","title":"AfterFrontImage_title__UBDFn"};